export default __webpack_public_path__ + "static/media/21.ccfc0d99.jpg";